import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { PENDING_ORGANIZATION_INVITATIONS } from "./pendingOrganizationInvitations";

const ORGANIZATION_INVITATION_REJECT = gql(`
  mutation organizationInvitationReject($invitationId: ID!){
    organizationInvitationReject(invitationId: $invitationId) {
      __typename
      ... on OrganizationInvitationRejected {
        __typename
        id
      }
      ... on OrganizationNotFound {
        __typename
      }
      ... on OrganizationInvitationNotFound {
        __typename
        id
      }
    }
  }
`);

export function useOrganizationInvitationReject() {
  return useMutation(ORGANIZATION_INVITATION_REJECT, {
    update: (cache, { data }, { variables }) => {
      const mutationSuccess =
        data?.organizationInvitationReject?.__typename ===
        "OrganizationInvitationRejected";
      if (!mutationSuccess) return cache;

      const invitationId = variables?.invitationId;
      if (!invitationId) return cache;

      cache.updateQuery(
        { query: PENDING_ORGANIZATION_INVITATIONS },
        (cachedPendingInvitationsQuery) => {
          if (!cachedPendingInvitationsQuery) return null;

          const cachedPendingInvitations =
            cachedPendingInvitationsQuery.me.pendingInvitations.filter(
              (i) => i.id !== invitationId
            ) || [];

          return {
            ...cachedPendingInvitationsQuery,
            me: {
              ...cachedPendingInvitationsQuery.me,
              pendingInvitations: cachedPendingInvitations
            }
          };
        }
      );

      return cache;
    }
  });
}
